import { TFunction } from "react-i18next";
import { GENERIC_ERROR_KEY } from "../Constants";

export const getErrorMessage = (t: TFunction<"translation", undefined>, key: string) => t([`errorMessages.${key}`, `errorMessages.${GENERIC_ERROR_KEY}`]);
